import { ca } from '@cian/analytics';

import { type SeriaPlusScheme } from 'shared/settings/seriaPlusScheme';

/**
 * @description Событие: блок «Серия Плюс» попал в зону видимости.
 */
export function trackShowSeriaPlusSection(scheme: SeriaPlusScheme): void {
  ca('eventSite', {
    action: 'show_landing_section',
    category: 'Promo',
    label: 'seria_plus',
    name: 'oldevent',
    products: scheme.media.map((media, index) => ({
      id: media.title,
      offerType: 'title',
      position: index,
    })),
  });
}
